import { useState } from 'react';
import { motion, useTransform } from 'motion/react';
import { Box } from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

const NAV_HEIGHT = 60;

const navItems = [
  { label: 'About' },
  { label: 'Projects' },
  { label: 'Find Me' },
];

function NavBar({ opacity, onAbout, onSocial, onMore }) {
  const [open, setOpen] = useState(false);
  const handlers = [onAbout, onMore, onSocial];
  const pointerEvents = useTransform(opacity, (o) => o < 0.05 ? 'none' : 'auto');

  return (
    <Box>
      {/* Tap-anywhere backdrop to close the menu (touch has no mouse-leave). */}
      {open && (
        <Box
          onClick={() => setOpen(false)}
          sx={{ position: 'fixed', inset: 0, zIndex: 99 }}
        />
      )}
      {/* Toggle - centered at top. The outer bar is pointer-transparent so it
          never covers the nav links; only the icon itself is interactive. */}
      <motion.div
        style={{
          opacity,
          pointerEvents: 'none',
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 101,
          display: 'flex',
          justifyContent: 'center',
          padding: '6px 1rem',
        }}
      >
        <motion.div
          onClick={() => setOpen(true)}
          whileHover={{ scale: 1.15 }}
          animate={{ opacity: open ? 0 : 1 }}
          transition={{ duration: 0.15, delay: open ? 0 : 0.35 }}
          style={{
            display: 'flex',
            cursor: 'pointer',
            pointerEvents: open ? 'none' : pointerEvents,
          }}
        >
          <MoreHorizIcon sx={{ fontSize: 24, color: 'white' }} />
        </motion.div>
      </motion.div>

      {/* Nav links - slides down to sit level with the toggle */}
      <motion.div
        onMouseLeave={() => setOpen(false)}
        initial={{ y: -NAV_HEIGHT }}
        animate={{ y: open ? 0 : -NAV_HEIGHT }}
        transition={{ duration: 0.4, ease: 'easeInOut' }}
        style={{
          opacity,
          pointerEvents,
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 100,
          height: NAV_HEIGHT,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 'clamp(1.5rem, 5vw, 3.5rem)',
          background: 'rgba(0,0,0,0.85)',
          backdropFilter: 'blur(10px)',
        }}
      >
        {navItems.map(({ label }, i) => (
          <motion.span
            key={label}
            whileHover={{ opacity: 0.5 }}
            onClick={() => { handlers[i]?.(); setOpen(false); }}
            style={{
              cursor: 'pointer',
              fontSize: '13px',
              letterSpacing: '2px',
              color: 'white',
              userSelect: 'none',
            }}
          >
            {label}
          </motion.span>
        ))}
      </motion.div>
    </Box>
  );
}

export default NavBar;
